import { render } from "./signup.page.vue?vue&type=template&id=05e3450a&ts=true"
import script from "./signup.page.vue?vue&type=script&lang=ts"
export * from "./signup.page.vue?vue&type=script&lang=ts"

import "./signup.page.vue?vue&type=style&index=0&id=05e3450a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__